export const CookiesHelpers = {
  get: () => Object.fromEntries(document.cookie.split('; ').map(x => x.split('='))),
  set: (name, value, days = 7, path = '/') => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString()
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=${path}`
  },
  delete: (name, path = '/') => {
    this.set(name, '', -1, path)
  },
}

export const numberOperations = {
  roundNumber: (num, scale) => {
    if (Math.round(num) !== num) {
      let sign = Math.sign(num);
      let arr = ('' + Math.abs(num)).split('.');
      if (arr.length > 1 && arr[1].length > scale) {
        let integ = +arr[0] * Math.pow(10, scale);
        let dec = integ + (+arr[1].slice(0, scale) + Math.pow(10, scale));
        let proc = +arr[1].slice(scale, scale + 1);
        if (proc >= 5) {
          dec = dec + 1;
        }
        dec = (sign * (dec - Math.pow(10, scale))) / Math.pow(10, scale);
        return dec;
      }
    }
    return num;
  },
};



export const behave = {
  debounce: (func, interval) => {
    let timeout
    return function() {
      let context = this,
        args = arguments
      let later = function() {
        timeout = null
        func.apply(context, args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, interval || 200)
    }
  },
}

//used for case and accents insensitive filters
export const normalizeAccents = text =>
  text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

export const areArrsEqual = (arr1, arr2) =>
  arr1.length === arr2.length && arr1.every((n, i) => n === arr2[i])

export const sort = arr => arr.sort((a, b) => a - b)
